import React from 'react';
import Button from '../../@base/Button';
import Input from '../../@base/Input';
import TagsInput from '../../TagsInput/TagsInput';
import style from './Entities.module.css';

const info = (
  <div>
    Sinônimos:
    {' '}
    <i className="fa fa-info-circle fa-sm" title="Utilize Tab, Enter ou virgulas para separar os termos" aria-hidden="true" />
  </div>
);

export function EntityDetailActions(props) {
  return (
    <div className={`${style.AddValues} row`}>
      <div className="col-3">
        <Input
          label="Valor:"
          small
          value={props.valueName}
          placeholder="Digite"
          onChange={(e) => props.setValueName(e.target.value)}
        />
      </div>
      <div className="col-7 ml-1">
        <TagsInput
          value={props.valueSynonyms}
          onChange={props.setValueSynonyms}
          label={info}
          placeholder="Digite"
          classes={style.TagsInput}
        />
      </div>
      <div className="col-1">
        <Button
          circle
          primary
          small
          classes={style.ButtonAddValues}
          onClick={props.saveValues}
          disabled={props.valueName.trim().length === 0}
        >
          <small>
            <i className="fa fa-plus" aria-hidden="true" />
          </small>
        </Button>
      </div>
    </div>
  );
}

export default EntityDetailActions;
